//Corresponding API model located in API project at
// API\IMS.Models\Services\Applications\Applications\AppRequests\NewAppRequest.cs
//Only edit if the NewAppRequest model or one of its dependencies were updated in the API causing error

export default class AppManagementRequest {
	//param @app : AppManagementModel
	//param @createdBy: user profile from useIdentify()
	//requirementNumber : string
	constructor(app, createdBy, requirementNumber) {
		this.App = app ? app : null;
		this.CreatedBy = createdBy ? createdBy.NetworkID : null;
		this.RequirementNumber = requirementNumber ? requirementNumber : null;
	}
}
